import { environment } from 'src/environments/environment'

const apiBase = environment.API_BASE

export const endpoints = Object.freeze({
  users: {
    list: `${apiBase}/users/`,
    token: `${apiBase}/users/token/`,
  },
  task: {
    tasks: {
      list: `${apiBase}/task/tasks/`,
      detail: (id: number) => `${apiBase}/task/tasks/${id}/`,
      assignments: {
        list: (taskId: number) =>
          `${apiBase}/task/tasks/${taskId}/assignments/`,
        detail: (taskId: number, assignmentId: number) =>
          `${apiBase}/task/tasks/${taskId}/assignments/${assignmentId}/`,
      },
    },
    groups: {
      list: `${apiBase}/task/groups/`,
      detail: (id: number) => `${apiBase}/task/groups/${id}/`,
    },
    labels: {
      list: `${apiBase}/task/labels/`,
      detail: (id: number) => `${apiBase}/task/labels/${id}/`,
    },
  },
  contacts: {
    list: `${apiBase}/contact/contacts/`,
    detail: (id: number) => `${apiBase}/contact/contacts/${id}/`,
  },
})
